import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { LikesDataService, LikesColumnsService } from '../../../services';
import { Like, LikesResult } from '../../../interfaces';

@Component({
  selector: 'app-like-form',
  templateUrl: './like-form.component.html',
  styleUrls: ['./like-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class LikeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public like: Like = {};
  public likeForm: FormGroup = new FormGroup({});
  public likes: Like[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private likesDataService: LikesDataService,
    public likesColumnsService: LikesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'LikeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Like - Edit');
        this.getLike(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.like !== 'undefined') {
      this.like = this.dynamicDialogConfig.data.like;
    }
    if (typeof this.like.id === 'undefined' || this.like.id === null) {
      this.like.id = null;
    }
    this.getLikes();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'LikeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'LikeFormComponent');
  }

  getLike(id: number): void {
    this.isLoading = true;
    this.likesDataService.getLike(id).subscribe((response: Like|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.like = response;
        this.prepareFrom();
      }
    });
  }

  getLikes(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.likes !== 'undefined' && this.dynamicDialogConfig.data.likes.length > 0) {
      this.likes = this.dynamicDialogConfig.data.likes;
      return;
    }
    this.likesDataService.getLikes(this.parameters).subscribe((response: LikesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.likes = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.likeForm = new FormGroup({
      id: new FormControl(this.like.id, []),
      entity: new FormControl(this.like.entity, [Validators.required, ]),
      foreignKey: new FormControl(this.like.foreignKey, [Validators.required, ]),
      value: new FormControl(this.like.value, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/likes']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.likeForm.controls).forEach((field: any) => {
        const control = this.likeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.likeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.like = this.likeForm.value;
    this.disableSubmit = true;
    console.log('like', this.like);
    if (typeof this.like.id !== 'undefined' && this.like.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.likesDataService.updateLike(this.like).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('LIKEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('LIKENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.likesDataService.addLike(this.like).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('LIKECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('LIKENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-like-form',
  templateUrl: './like-form.component.html',
  styleUrls: ['./like-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogLikeFormComponent extends LikeFormComponent {
}

